import React, { useState } from "react";
import { Outlet, Link, useNavigate } from "react-router-dom";
import { Flowbite, Navbar, Dropdown, Avatar, Sidebar } from "flowbite-react";

import { HiCurrencyDollar } from "react-icons/hi";

import { MdManageAccounts, MdCreateNewFolder } from "react-icons/md";
import { SiFiles } from "react-icons/si";
import { FaTasks, FaPeopleCarry } from "react-icons/fa";
import { ImFolderUpload } from "react-icons/im";
import { AiFillFileAdd } from "react-icons/ai";
import { useAuth } from "../context/AuthContextHelper";
import { useModal } from "../context/ModalContextHelper";

const DashboardLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { logoutUser, user } = useAuth();

  const { setOpenModalFileUpload, setOpenModalFolder, setFolderModalFor } =
    useModal();

  const navigate = useNavigate();

  return (
    <>
      <Flowbite>
        <div className="dark:bg-gray-900">
          <header>
            <Navbar fluid border className="fixed w-full top-0 left-0 z-40">
              <div className="flex items-center">
                <button
                  data-drawer-target="default-sidebar"
                  data-drawer-toggle="default-sidebar"
                  aria-controls="default-sidebar"
                  type="button"
                  className="inline-flex items-center p-2 text-sm text-gray-500 rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
                  onClick={() => {
                    setSidebarCollapsed(!sidebarCollapsed);
                    setIsOpen(!isOpen);
                  }}
                >
                  <span className="sr-only">Open sidebar</span>
                  <svg
                    className="w-6 h-6"
                    aria-hidden="true"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      clipRule="evenodd"
                      fillRule="evenodd"
                      d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
                    ></path>
                  </svg>
                </button>
                <div className="ml-4">
                  <Navbar.Brand as={"div"}>
                    <Link to={"dashboard/tasks"}>
                      <img
                        src={process.env.PUBLIC_URL + "/Sharevance logo.png"}
                        className="mr-3 h-6 sm:h-9"
                        alt="Flowbite React Logo"
                      />
                    </Link>
                  </Navbar.Brand>
                </div>
              </div>
              <div className="flex md:order-2 items-center">
                <div className="font-bold mr-2 hidden md:block">
                  {user && user.first_name + " " + user.last_name}
                </div>
                <Dropdown
                  arrowIcon={false}
                  inline
                  label={<Avatar alt="User settings" rounded icon={"true"} />}
                >
                  <Dropdown.Header>
                    <span className="block text-md font-bold mb-1">
                      {user && user.first_name + " " + user.last_name}
                    </span>
                    <span className="block truncate text-sm font-sm">
                      {user && user.email}
                    </span>
                  </Dropdown.Header>
                  <Dropdown.Divider />
                  <Dropdown.Item
                    onClick={() => {
                      logoutUser();
                    }}
                  >
                    Sign out
                  </Dropdown.Item>
                </Dropdown>
              </div>
            </Navbar>
          </header>
          <div className="flex h-screen">
            <aside
              id="default-sidebar"
              className={`fixed top-0 left-0 h-screen pt-16 transition-transform border-r border-gray-200 bg-[#003464] dark:bg-gray-800 dark:border-gray-600 flex-shrink-0 z-20 sm:translate-x-0 ${
                sidebarCollapsed && "-translate-x-full"
              }`}
              aria-label="Sidebar"
            >
              <Sidebar
                collapsed={sidebarCollapsed}
                as="div"
                theme={{
                  root: {
                    inner: "h-full overflow-y-auto py-4 px-3 dark:bg-gray-800",
                  },
                }}
              >
                <Sidebar.Items className="h-full">
                  <Sidebar.ItemGroup className="h-1/2">
                    <Link to="/dashboard/tasks">
                      <Sidebar.Item
                        as="div"
                        icon={FaTasks}
                        theme={{
                          icon: {
                            base: "h-6 w-6 flex-shrink-0 text-white transition duration-75",
                          },
                        }}
                        className="flex items-center justify-center rounded-md p-2 text-base font-bold text-white hover:bg-[#c96b1a] tracking-tighter"
                      >
                        <p>Dashboard</p>
                      </Sidebar.Item>
                    </Link>
                    <Link to={"/dashboard/files-manager"}>
                      <Sidebar.Item
                        as="div"
                        icon={SiFiles}
                        theme={{
                          icon: {
                            base: "h-6 w-6 flex-shrink-0 text-white transition duration-75",
                          },
                        }}
                        className="flex items-center justify-center rounded-md p-2 text-base font-bold text-white hover:bg-[#c96b1a] tracking-tighter"
                      >
                        <p>File Manager</p>
                      </Sidebar.Item>
                    </Link>

                    <Sidebar.Item
                      icon={HiCurrencyDollar}
                      as="div"
                      theme={{
                        icon: {
                          base: "h-6 w-6 flex-shrink-0 text-white transition duration-75",
                        },
                      }}
                      className="flex items-center justify-center rounded-md p-2 text-base font-bold text-white hover:bg-[#c96b1a] tracking-tighter"
                    >
                      <p>Valuation</p>
                    </Sidebar.Item>
                    <Link to={"dashboard/employee-management"}>
                      <Sidebar.Item
                        icon={MdManageAccounts}
                        as="div"
                        theme={{
                          icon: {
                            base: "h-6 w-6 flex-shrink-0 text-white transition duration-75",
                          },
                        }}
                        className="flex items-center justify-center rounded-md p-2 text-base font-bold text-white hover:bg-[#c96b1a] tracking-tighter"
                      >
                        <p>Employee Management</p>
                      </Sidebar.Item>
                    </Link>
                    <Link to={"dashboard/esop"}>
                      <Sidebar.Item
                        icon={FaPeopleCarry}
                        as="div"
                        theme={{
                          icon: {
                            base: "h-6 w-6 flex-shrink-0 text-white transition duration-75",
                          },
                        }}
                        className="flex items-center justify-center rounded-md p-2 text-base font-bold text-white hover:bg-[#c96b1a] tracking-tighter"
                      >
                        <p>ESOP Plan Design</p>
                      </Sidebar.Item>
                    </Link>
                  </Sidebar.ItemGroup>
                  <div className="w-full flex flex-row justify-center">
                    <span className="text-sm font-bold text-white tracking-tighter text-center">
                      Quick Links
                    </span>
                  </div>
                  <Sidebar.ItemGroup>
                    <Sidebar.Collapse
                      icon={ImFolderUpload}
                      theme={{
                        icon: {
                          base: "h-6 w-6 flex-shrink-0 text-white transition duration-75",
                          open: {
                            on: true,
                          },
                        },
                      }}
                      label="Upload"
                      className="flex items-center justify-center rounded-md p-2 text-base font-bold text-white hover:bg-[#c96b1a] tracking-tighter"
                    >
                      <Sidebar.Item
                        className="flex items-center justify-center rounded-md p-2 text-base font-bold text-white hover:bg-[#c96b1a] group w-full transition duration-75 cursor-pointer"
                        icon={AiFillFileAdd}
                        as="div"
                        theme={{
                          icon: {
                            base: "h-6 w-6 flex-shrink-0 transition duration-75",
                          },
                        }}
                        onClick={() => {
                          navigate("/dashboard/files-manager");
                          setOpenModalFileUpload("dismissible");
                        }}
                      >
                        File
                      </Sidebar.Item>
                      <Sidebar.Item
                        icon={MdCreateNewFolder}
                        as="div"
                        theme={{
                          icon: {
                            base: "h-6 w-6 flex-shrink-0 transition duration-75",
                          },
                        }}
                        className="flex items-center justify-center rounded-md p-2 text-base font-bold text-white hover:bg-[#c96b1a] group w-full transition duration-75 cursor-pointer"
                        onClick={() => {
                          navigate("/dashboard/files-manager");
                          setFolderModalFor("create");
                          setOpenModalFolder("popup");
                        }}
                      >
                        Folder
                      </Sidebar.Item>
                    </Sidebar.Collapse>
                  </Sidebar.ItemGroup>
                </Sidebar.Items>
              </Sidebar>
            </aside>
            <div
              id="main-content"
              className={`${
                sidebarCollapsed ? "sm:ml-16" : "sm:ml-64"
              } mt-16 p-4 rounded-md w-full relative overflow-y-auto`}
            >
              <Outlet />
            </div>
          </div>
        </div>
      </Flowbite>
    </>
  );
};

export default DashboardLayout;
